import { useCallback } from 'react'
import { setUserProperties, logEvent, setUserId } from '@firebase/analytics'
import { useStytchB2BClient } from '@stytch/react/b2b'
import { analytics } from '@/feature_flags/firebase_config'
import { SESSION_DURATION_MINUTES } from '@/utils/auth'

export async function logEventsForFirebase(userName: string, email: string) {
  try {
    // Setup google analytics user for feature flagging.
    // Without this, internal_user condition doesn't work.
    const analyticsResult = await analytics()
    if (analyticsResult) {
      setUserId(analyticsResult, userName)
      setUserProperties(analyticsResult, {
        email,
        is_internal_user:
          email.endsWith('@zerapix.com') || email.endsWith('@pixydocs.com'),
      })
      logEvent(analyticsResult, 'login', {
        method: 'Stytch',
      })
    }
  } catch (e) {
    console.error('Error logging events for firebase', e)
  }
}

export default function useAuthentication() {
  const stytch = useStytchB2BClient()

  const getFreshIdToken = useCallback(async () => {
    const response = await stytch.session.authenticate({
      session_duration_minutes: SESSION_DURATION_MINUTES,
    })
    return response.session_jwt
  }, [stytch])

  return {
    getFreshIdToken,
  }
}
